export const albumLinks = [
   {
        id: 1 ,
        title: 'Spotify',
        link: 'https://open.spotify.com/album/7kviuNhdtKvSzdi1z2gnYS?si=ogYwsQUTTa-ZoJHbhYcDTQ',
        fontAwesome: '',
        description: 'Stream'
    },
    {
        id: 1 ,
        title: 'Apple Music',
        link: 'https://music.apple.com/ch/album/the-marble-geier-experience/1656466464',
        fontAwesome: '',
        description: 'Stream and Buy'
    },
    {
        id: 1 ,
        title: 'iTunes',
        link: 'https://music.apple.com/ch/album/the-marble-geier-experience/1656466464?uo=4',
        fontAwesome: '',
        description: 'Stream and Buy'
    },
    // {
    //     id: 1 ,
    //     title: 'Deezer',
    //     link: '',
    //     fontAwesome: '',
    //     description: 'Stream'
    // },
    {
        id: 1 ,
        title: 'Bandcamp',
        link: 'https://mageix.bandcamp.com/album/the-marble-geier-experience',
        fontAwesome: '',
        description: 'Buy & Listen'
    },
    {
        id: 1 ,
        title: 'Soundcloud',
        link: 'https://soundcloud.com/themarblegeierexperience/sets/the-marble-geier-experience',
        fontAwesome: '',
        description: 'Listen'
    },
    {
        id: 1 ,
        title: 'Youtube',
        link: 'https://www.youtube.com/watch?v=C99ehZaoN-I&list=PLWLvRkIC6AtdFiXtqLJP8pw3xeQsoBr-D',
        fontAwesome: '',
        description: 'Full Album Playlist'
    },
    /*{
        id: 1 ,
        title: 'Youtube',
        link: 'https://youtu.be/6hui95AvaGg',
        fontAwesome: '',
        description: 'Wisenheimer Waltz'
    },
    {
        id: 1 ,
        title: 'Youtube',
        link: 'https://youtu.be/sz1f3yBDaPg',
        fontAwesome: '',
        description: 'Dumbo Gets Mad'
    },*/
]